import * as types from '../../mutation-types'
import reportsApi from '../../../api/reports'

const state = {
  reportsDetails: JSON.parse(localStorage.getItem('user-store-reports') || '{}'),
  eodReportsDetails: [],
  eodErrorMessage: null,
  showReportsPopup: false
}
// getters
const getters = {
  reportsDetails: state => state.reportsDetails,
  eodReportsDetails: state => state.eodReportsDetails,
  eodErrorMessage: state => state.eodErrorMessage,
  showReportsPopup: state => state.showReportsPopup
}

const actions = {
  reportsLogin ({commit, state}, user) {
    commit(types.LOADING_START)
    commit(types.REPORTS_LOGIN)
    // Now call the login api
    return new Promise((resolve, reject) => {
      reportsApi.reportsLogin(user)
        .then((user) => {
          if (user.status === 'Success') {
            commit(types.REPORTS_LOGIN_SUCCESS, user)
            resolve(user)
          } else {
            commit(types.REPORTS_LOGIN_FAILURE, user.error)
            reject(user)
          }
        })
        .catch((reason) => {
          commit(types.REPORTS_LOGIN_FAILURE, reason)
          reject(reason)
        })
        .finally(() => {
          commit(types.LOADING_END)
        })
    })
  },
  reprtsPopupShow ({commit, state}) {
    commit(types.REPORTS_POPUP_SHOW)
  },
  reprtsPopupHide ({commit, state}) {
    commit(types.REPORTS_POPUP_HIDE)
  },
  getReportsRange ({commit, state}, range) {
    commit(types.LOADING_START)
    commit(types.REPORTS_REQUEST)
    // Now call the login api
    return new Promise((resolve, reject) => {
      reportsApi.getReports(range)
        .then((range) => {
          console.log(range)
          commit(types.REPORTS_REQUEST_SUCCESS, range)
          resolve(range)
        })
        .catch((reason) => {
          commit(types.REPORTS_REQUEST_FAILURE, reason)
          reject(reason)
        })
        .finally(() => {
          commit(types.LOADING_END)
        })
    })
  },
  getEODReports ({ commit, state }, range) {
    commit(types.LOADING_START)
    commit(types.EODREPORTS_REQUEST)
    return new Promise((resolve, reject) => {
      reportsApi.getEndOfDayReports(range)
        .then((res) => {
          commit(types.EODREPORTS_REQUEST_SUCCESS, res)
          resolve(res)
        })
        .catch((reason) => {
          commit(types.EODREPORTS_REQUEST_FAILURE, reason)
          reject(reason)
        })
        .finally(() => {
          commit(types.LOADING_END)
        })
    })
  },
  logOut ({commit}) {
    commit(types.LOGOUT)
  },
  postEODReports ({commit}, {tid, reports}) {
    commit(types.LOADING_START)
    return reportsApi.createEndOfDayReports({tid, reports})
    .then((result) => {
      commit(types.LOADING_END)
      return result
    })
  }
}

const mutations = {
  [types.REPORTS_LOGIN] (state) {
    state.reportsDetails = {}
    localStorage.setItem('user-store-reports', '{}')
  },
  [types.REPORTS_LOGIN_SUCCESS] (state, report) {
    state.reportsDetails = report
    console.log(report)
    localStorage.setItem('user-store-reports', JSON.stringify(report))
  },
  [types.REPORTS_LOGIN_FAILURE] (state, reason) {
    state.loginFailedStatus = reason.toString()
  },
  [types.REPORTS_REQUEST] (state) {
    state.reportsDetails = {}
    localStorage.setItem('user-store-reports', '{}')
  },
  [types.REPORTS_REQUEST_SUCCESS] (state, report) {
    state.reportsDetails = report
    console.log(report)
    localStorage.setItem('user-store-reports', JSON.stringify(report))
  },
  [types.REPORTS_REQUEST_FAILURE] (state, reason) {
    state.loginFailedStatus = reason.toString()
  },
  [types.EODREPORTS_REQUEST] (state) {
    state.eodReportsDetails = {}
  },
  [types.EODREPORTS_REQUEST_SUCCESS] (state, Eodreport) {
    state.eodReportsDetails = Eodreport.data || []
  },
  [types.EODREPORTS_REQUEST_FAILURE] (state, reason) {
    state.eodErrorMessage = reason.toString()
  },
  [types.REPORTS_POPUP_SHOW] (state) {
    state.showReportsPopup = !state.showReportsPopup
  },
  [types.REPORTS_POPUP_HIDE] (state) {
    state.showReportsPopup = !state.showReportsPopup
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/reports/index.js